import _ from "lodash";

class LayoutUtils {
  static getRect(layout) {
    let rect = _.pick(layout, ["x", "y", "w", "h"]);
    rect.x2 = rect.x + rect.w;
    rect.y2 = rect.y + rect.h;

    return rect;
  }

  static getBoundingRect(/** Array **/ rects) {
    let bounds = _.clone(rects[0]);

    for (var i = 1; i < rects.length; i++) {
      let rect = rects[i];

      if (rect.x < bounds.x) {
        bounds.x = rect.x;
      }

      if (rect.x2 > bounds.x2) {
        bounds.x2 = rect.x2;
      }

      if (rect.y < bounds.y) {
        bounds.y = rect.y;
      }

      if (rect.y2 > bounds.y2) {
        bounds.y2 = rect.y2;
      }
    }

    bounds.w = bounds.x2 - bounds.x;
    bounds.h = bounds.y2 - bounds.y;

    return bounds;
  }

  /**
   * Does rectangle A contain rectangle B
   * @param rectA
   * @param rectB
   * @private
   */
  static isRectContained(/** Object **/ rectA, /** Object **/ rectB) {
    return rectA.x <= rectB.x && rectB.x2 <= rectA.x2 && rectA.y <= rectB.y && rectB.y2 <= rectA.y2;
  }

  static getRectRelationship(/** Object **/ rectA, /** Object **/ rectB) {
    return {
      contains: LayoutUtils.isRectContained(rectA, rectB),
      contained: LayoutUtils.isRectContained(rectB, rectA),
      overlap: LayoutUtils.getRectOverlapPercentage(rectA, rectB),
    };
  }

  static getRectOverlapPercentage(/** Object **/ rectA, /** Object **/ rectB) {
    if (_.isEqual(rectA, rectB)) {
      return 1;
    }

    let areaA = rectA.w * rectA.h;
    let areaB = rectB.w * rectB.h;

    let areaI =
      Math.max(0, Math.min(rectA.x2, rectB.x2) - Math.max(rectA.x, rectB.x)) *
      Math.max(0, Math.min(rectA.y2, rectB.y2) - Math.max(rectA.y, rectB.y));
    let areaU = areaA + areaB - areaI;

    let overlap = areaI / areaU;

    return overlap;
  }
}

export default LayoutUtils;
